export default __webpack_public_path__ + "static/media/imgMiPad.e64e5546.png";